import { Link } from 'react-router-dom';
import LegalPage, { Section } from './LegalPage';

export default function ResponsibleGamblingPage() {
  return (
    <LegalPage
      title="Responsible Gambling"
      intro="Betting should be fun and for entertainment only. Gambling can be addictive. My Bets is committed to keeping betting safe — never bet more than you can afford to lose."
    >
      <Section heading="Free, confidential help — 24/7">
        <p>
          If gambling is no longer fun, or you are worried about yourself or someone else,
          the South African Responsible Gambling Foundation helpline is free, confidential
          and open 24 hours a day:
        </p>
        <p className="text-lg font-bold text-text-primary">
          <a href="tel:0800006008" className="text-primary hover:underline">
            0800 006 008
          </a>
        </p>
        <p>You can also SMS the word “HELP” to the helpline to request a call back.</p>
      </Section>

      <Section heading="Deposit limits">
        <p>
          You can set a daily, weekly or monthly deposit limit on your account at any time.
          Once a limit is set, you cannot deposit more than that amount in the chosen period.
          Lowering a limit takes effect immediately; raising a limit only takes effect after
          a cooling-off period.
        </p>
      </Section>

      <Section heading="Time-outs">
        <p>
          Need a short break? A time-out temporarily locks you out of betting for a period you
          choose (for example 24 hours, 7 days or 30 days). You will not be able to place bets
          during a time-out, but you can still withdraw any balance.
        </p>
      </Section>

      <Section heading="Self-exclusion">
        <p>
          Self-exclusion closes your account to betting for a longer, fixed period. While
          self-excluded you cannot log in to bet, and we will not send you marketing. This is a
          serious step designed to protect you — please contact support or use the tools in your
          account to begin.
        </p>
      </Section>

      <Section heading="Session reminders">
        <p>
          You can enable reminders that tell you how long you have been playing, so you stay aware
          of time and money spent.
        </p>
      </Section>

      <Section heading="Tips for staying in control">
        <ul className="list-disc space-y-1 pl-5">
          <li>Only bet money you can afford to lose.</li>
          <li>Set a budget and a time limit before you start.</li>
          <li>Never chase losses — betting is not a way to make money.</li>
          <li>Don&apos;t bet when upset, stressed or under the influence.</li>
          <li>Take regular breaks.</li>
        </ul>
      </Section>

      <Section heading="Under 18s">
        <p>
          Betting is strictly for adults aged 18 and older. We verify the age and identity of
          every customer at registration. It is an offence for anyone under 18 to gamble.
        </p>
      </Section>

      <p className="text-sm text-text-muted">
        See also our{' '}
        <Link to="/terms" className="font-semibold text-primary hover:underline">
          Terms &amp; Betting Rules
        </Link>{' '}
        and{' '}
        <Link to="/privacy" className="font-semibold text-primary hover:underline">
          Privacy notice
        </Link>
        .
      </p>
    </LegalPage>
  );
}
